import * as React from 'react';
import { useRef } from 'react';
import { createViewConfig } from '@sail/engine';
import { css, view } from '@sail/ui';
import { useId } from '@sail/react-aria';
import { Stripe } from './Stripe';
import { useStripeSetAnimation } from './useStripeSetAnimation';
export const StripeSetConfig = createViewConfig({
    props: {},
    name: 'StripeSet'
});
export const StripeSet = StripeSetConfig.createView(({ stripes, position, align, ...props })=>{
    const intersectionRef = useRef(null);
    const ref = useRef(null);
    const alignEnd = align === 'end' || position === 'bottom-left' || position === 'bottom-right';
    useStripeSetAnimation({
        ref,
        intersectionRef,
        alignEnd
    });
    return /*#__PURE__*/ React.createElement(view.div, {
        ...props,
        ref: ref
    }, stripes.map((stripeProps, i)=>/*#__PURE__*/ React.createElement(Stripe, {
            key: useId(),
            ...stripeProps,
            position: position,
            order: i === 0 ? 'first' : 'second'
        })), stripes[1] && /*#__PURE__*/ React.createElement(Stripe, {
        intersectionRef: intersectionRef,
        type: "intersection",
        inset: stripes[0].inset,
        width: stripes[0].width,
        intersectionInset: stripes[1].inset,
        intersectionWidth: stripes[1].width,
        accent: stripes[1].accent,
        position: position,
        order: "last"
    }));
}, {
    forward: {
        position: true,
        align: true
    },
    uses: [
        css({
            display: 'block'
        }),
        css({
            '--stripeSetHeight': '72px',
            '--stripeSetAlignCenterOffset': '-40px',
            '--stripeSetSubpixelOffset': '0',
            '--stripeSetAngle': '-6deg'
        })
    ],
    css: {
        position: 'absolute',
        height: 'var(--stripeSetHeight)',
        width: 'fill',
        transform: `skewY(var(--stripeSetAngle)) translateY(var(--stripeSetSubpixelOffset))`,
        overflow: 'hidden'
    },
    variants: {
        position: {
            'top-left': css({
                top: 'space.0',
                left: 'space.0',
                transformOrigin: '100% 0'
            }),
            'top-right': [
                css({
                    top: 'space.0',
                    right: 'space.0',
                    transformOrigin: '100% 0'
                }),
                css({
                    '--stripeSetSubpixelOffset': '-0.35px'
                })
            ],
            'bottom-left': css({
                left: 'space.0',
                bottom: 'space.0',
                transformOrigin: '0 100%'
            }),
            'bottom-right': [
                css({
                    right: 'space.0',
                    bottom: 'var(--sectionAngleHeight)',
                    transformOrigin: '100% 100%'
                }),
                css({
                    '--stripeSetSubpixelOffset': '-0.35px'
                })
            ]
        },
        align: {
            center: css({
                top: 'var(--stripeSetAlignCenterOffset)'
            }),
            end: css({
                top: 'calc(var(--stripeSetHeight) * -1)'
            })
        }
    }
});

//# sourceMappingURL=StripeSet.js.map